export const impactAxes = [
  { 
    id: 1, 
    name: "EJE I: Formación académica y de vanguardia",
    description: "<p><strong>Objetivo:</strong> Garantizar una educación media superior y superior de calidad, pertinente, innovadora e incluyente, que promueva la formación integral de las y los estudiantes a través de programas académicos actualizados, que coadyuven a resolver las necesidades del país y del estado, mediante el uso estratégico de nuevas tecnologías y metodologías pedagógicas de vanguardia, permitiendo así la generación y difusión de conocimiento que haga frente a los desafíos actuales y futuros de la sociedad.</p><p><strong>Líneas de acción:</strong></p><ul><li><strong>1.1.</strong> Fortalecimiento del modelo educativo UAS.</li><li><strong>1.2.</strong> Oferta educativa acorde a las necesidades futuras, nacionales e internacionales.</li><li><strong>1.3.</strong> Actualización integral docente y formación continua.</li><li><strong>1.4.</strong> Evaluación del desempeño académico institucional.</li><li><strong>1.5.</strong> Acceso a recursos académicos digitales.</li></ul>"
  },
  { 
    id: 2, 
    name: "EJE II: Investigación y transferencia del conocimiento",
    description: `
      <p>
        <strong>Objetivo:</strong>
        Fortalecer el reconocimiento nacional e internacional de la Institución, a través de la calidad e impacto de su investigación, desarrollo tecnológico y formación de recursos humanos de alto nivel, que contribuyan a la generación del conocimiento, la divulgación científica y la transferencia tecnológica, de manera que incidan en el desarrollo de nuestro entorno y la disminución de las desigualdades económicas, sociales y culturales.
      </p>
      <h3>Líneas de acción:</h3>
      <ul>
        <li><strong>2.1</strong> Producción, divulgación y transferencia de conocimiento.</li>
        <li><strong>2.2</strong> Consolidación y evaluación de centros y grupos de investigación.</li>
        <li><strong>2.3</strong> Programas de posgrado con enfoque en investigación de frontera.</li>
        <li><strong>2.4</strong> Redes de colaboración nacionales e internacionales para el desarrollo de la investigación.</li>
      </ul>
    `
  },
  { 
    id: 3, 
    name: "EJE III: Extensión universitaria con responsabilidad social",
    description: `
      <p>
        <strong>Objetivo:</strong>
        Fortalecer la vinculación y el compromiso social de la comunidad universitaria con su entorno local, nacional e internacional, mediante la creación, difusión y extensión del arte, la cultura, la ciencia y el deporte. Promover estas expresiones como estrategias de intervención transformadora, que impulsen el desarrollo humano y comunitario, contribuyan al bienestar social y posicionen a la Universidad como un agente activo en la construcción de un desarrollo equitativo y sostenible del estado y del país.
      </p>

      <h3>Líneas de acción:</h3>
      <ul>
        <li><strong>3.1</strong> Bienestar, identidad y servicio comunitario.</li>
        <li><strong>3.2</strong> Fomento institucional de las artes y la cultura.</li>
        <li><strong>3.3</strong> Formación deportiva y de alto rendimiento.</li>
        <li><strong>3.4</strong> Universidad con perspectiva de género.</li>
      </ul>
    `
  },
  { 
    id: 4, 
    name: "EJE IV: Vinculación estratégica para el desarrollo",
    description: `
      <p>
        <strong>Objetivo:</strong>
        Impulsar la construcción de alianzas estratégicas y relaciones de colaboración interinstitucional con organismos de los sectores público, privado y social, a nivel regional, nacional e internacional, con el propósito de fortalecer el desarrollo de las funciones sustantivas de la Universidad. Estas alianzas promoverán la investigación aplicada, la innovación social, la formación integral y la empleabilidad del estudiantado mediante la implementación de un modelo de formación que articule conocimientos teóricos y práctica profesional, contribuyendo al impacto y proyección de la Universidad en su entorno.
      </p>

      <h3>Líneas de acción:</h3>
      <ul>
        <li><strong>4.1</strong> Alianzas estratégicas con los sectores productivo y social.</li>
        <li><strong>4.2</strong> Proyectos con impacto sostenible, comunitario e internacional.</li>
        <li><strong>4.3</strong> Emprendimiento e innovación.</li>
        <li><strong>4.4</strong> Movilidad estudiantil y académica.</li>
      </ul>
    `
  },
  { 
    id: 5, 
    name: "EJE V: Gestión con enfoque en resultados",
    description: `
      <p>
        <strong>Objetivo:</strong>
        Optimizar la gestión institucional de la Universidad mediante un modelo basado en resultados y la mejora continua, que garantice la toma de decisiones estratégicas y el uso responsable de los recursos, en función de asegurar el cumplimiento de sus funciones sustantivas, fortaleciendo su impacto en el desarrollo académico, social y económico.
      </p>

      <h3>Líneas de acción:</h3>
      <ul>
        <li><strong>5.1</strong> Planeación vinculada al presupuesto.</li>
        <li><strong>5.2</strong> Gestión estratégica de recursos financieros y materiales.</li>
        <li><strong>5.3</strong> Herramientas digitales, automatización y mejora de procesos.</li>
        <li><strong>5.4</strong> Seguimiento y evaluación del desempeño institucional.</li>
      </ul>
    `
  },
  { 
    id: 6, 
    name: "EJE VI: Gobernanza y transparencia universitaria",
    description: `
      <p>
        <strong>Objetivo:</strong>
        Fortalecer la Universidad como espacio de convergencia y catalizador para el desarrollo de políticas institucionales, mediante nuevas formas de colaboración de la mano de su comunidad, promoviendo un modelo de gestión participativa, ética y responsable, que garantice la rendición de cuentas, la confianza social y el cumplimiento de la normatividad vigente en todas sus funciones sustantivas.
      </p>

      <h3>Líneas de acción:</h3>
      <ul>
        <li><strong>6.1</strong> Mecanismos de participación y toma de decisiones.</li>
        <li><strong>6.2</strong> Medios y estrategias para la transparencia y rendición de cuentas.</li>
        <li><strong>6.3</strong> Auditoría y control interno.</li>
        <li><strong>6.4</strong> Clima organizacional y bienestar laboral.</li>
      </ul>
    `
  }
];

export const statusOptions: Record<string, string> = {
  SUBMITTED: "ENVIADA",
  OBSERVATION: "OBSERVACIÓN",
  RESOLVED: "RESUELTA",
  AUTHORIZED: "AUTORIZADA",
  DONE: "COMPLETADA",
  FINISHED: "FINALIZADA",
};

export const workPlanStatuses = [
    "Submitted",
    "Observation",
    "Resolved",
    "Authorized",
    "Finalized"
];
